/**
 * Apartsales — Карта (Tab 4).
 *
 * Geographic discovery surface — map with property pins clustered by
 * region/city/district, drill-down to ЖК cards.
 *
 * Composition (to be built):
 *   1. Full-screen map (MapLibre + OSM or Yandex Maps SDK)
 *   2. Search-by-area overlay (drag rectangle → filter properties)
 *   3. Cluster pins → tap to expand list
 *   4. Bottom-sheet with PropertyCards for current viewport
 *   5. Geographic awareness: nearest metro, beaches, schools
 *
 * Stub for now.
 */

import { createFileRoute } from '@tanstack/react-router';

import { TabStub } from '~/components/TabStub';

export const Route = createFileRoute('/map')({
  component: MapScreen,
});

function MapScreen() {
  return (
    <TabStub
      title="Карта"
      subtitle="Гео-discovery с кластерами и slow-search"
      description="Полноэкранная карта с пинами по ЖК, кластеризацией по регионам/городам/районам. Slow-search через прямоугольник, bottom-sheet с PropertyCard для текущего viewport. Метро, пляжи, школы — встроены."
      docRef="docs/architecture/25 §6"
    />
  );
}
